import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { getV3Api } from "../../apiConfiguration";
import { getExistingLaterals } from "../../state/existingEvents";
import { getSimulationStatus } from "../../state/simulation";
import { menuExistingItemCardRow } from "../../styles/styleComposition";
import { simulationIdFromUrl } from "../../utils/apiUtils";
import ExistingItemsContainer from "../ExistingItemsContainer";

import ExistingItemCard from "./ExistingItemCard";

interface ExistingDischargeProps {
  discharge: api.ConstantLateral;
}

interface ExistingDischargesProps {
  isPump: boolean;
}

const ExistingDischarge: React.FC<ExistingDischargeProps> = ({ discharge }) => {
  const simulationStatus = useSelector(getSimulationStatus);
  const simulationTime = simulationStatus.time;

  const onDelete = useCallback(async () => {
    const v3Api = getV3Api();
    if (discharge && discharge.id && discharge.simulation) {
      try {
        await v3Api.simulationsEventsLateralConstantDelete({
          id: discharge.id,
          simulationPk: simulationIdFromUrl(discharge.simulation),
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [discharge]);

  const onStop = useCallback(async () => {
    const v3Api = getV3Api();
    if (discharge && discharge.id && discharge.simulation) {
      try {
        await v3Api.simulationsEventsLateralConstantPartialUpdate({
          id: discharge.id,
          simulationPk: simulationIdFromUrl(discharge.simulation),
          //@ts-ignore
          data: {
            duration: Math.max(simulationTime + 1 - discharge.offset, 1),
          },
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [discharge, simulationTime]);

  return (
    <ExistingItemCard
      onDelete={discharge.simulation ? onDelete : undefined}
      onStop={discharge.simulation ? onStop : undefined}
      start={discharge.offset}
      end={
        discharge.duration !== null && discharge.duration !== undefined
          ? discharge.offset + discharge.duration
          : undefined
      }
      controlType="editDischarge"
    >
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage
            id="newDischargeMenu.amount_of_water_label"
            defaultMessage="Amount of water"
          />
          :
        </span>
        <span>
          {Math.abs(discharge.value)}{" "}
          <FormattedMessage id="newDischargeMenu.amount_of_water_unit_m3/s" defaultMessage="m³/s" />
        </span>
      </div>
    </ExistingItemCard>
  );
};

const ExistingDischarges: React.FC<ExistingDischargesProps> = ({ isPump }) => {
  const existingLaterals = useSelector(getExistingLaterals);
  const existingDischarges = existingLaterals.filter((d) => (isPump ? d.value < 0 : d.value > 0));

  return (
    <ExistingItemsContainer>
      {existingDischarges.map((discharge) => (
        <ExistingDischarge
          key={discharge.point && discharge.point?.coordinates[0] + discharge.point?.coordinates[1]}
          discharge={discharge}
        />
      ))}
    </ExistingItemsContainer>
  );
};

export default ExistingDischarges;
